module.exports = __webpack_public_path__ + "static/media/card-gold.9c9abd85.png";